

exports.__esModule = true;
exports.customUtil = undefined;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _constants = require('./constants');

var paramCache = {};


function parameters(string) {

    if (typeof string !== 'string') {
        string = _squid.$util.queryString().slice(1);
    }

    var params = {};

    if (!string) {
        return params;
    }

    if (paramCache[string]) {
        return paramCache[string];
    }

    _squid.$util.forEach(string.split('&'), function (pair) {
        pair = pair.split('=');

        if (pair[0] && pair[1]) {
            try {
                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            } catch (err) {
                _logger.$logger.info('decodeURIComponentError', {
                    key: pair[0],
                    value_mapped: _constants.PII_XCLICK_PARAMS.indexOf(pair[0]) > -1 ? _constants.MASKED_LOG : pair[1] });
                params[decodeURIComponent(pair[0])] = pair[1];
            }
        }
    });

    paramCache[string] = params;

    return params;
}

var customUtil = exports.customUtil = {
    /*
     * decodeAndParse :
     * 1 - Base64Decode
     * 2 - URI Decode
     * 3 - Split string into a nvp object
     * return obj
     */
    decodeAndParse: function decodeAndParse(encodedString) {
        if (encodedString) {
            return parameters(decodeURIComponent(_squid.$util.base64Decode(encodedString)));
        }
    }
};

_squid.$util;

_logger.$logger;

_constants.PII_XCLICK_PARAMS;

_constants.MASKED_LOG;


//////////////////
// WEBPACK FOOTER
// ./js/lib/customUtil.js
// module id = ./js/lib/customUtil.js
// module chunks = 0